import { takeLatest, call, put, all } from 'redux-saga/effects';
import { ApiResponse, getApi } from 'services/rotasp/api';
import { PATH_SGU_API } from 'services/rotasp/path';
import { ReducerActionRotaSP } from 'store/modules/types';
import { cleanEmpty } from 'utils/genericFunctions';
import { ConsultarOrgaosRequest, Types } from './types';
import { consultarOrgaoSuccess, consultarOrgaoFailure } from './actions';

// UTILS

function* consultarOrgaoRequest(request: ReducerActionRotaSP) {
	const {
		token,
		payload,
	}: { token?: string; payload: ConsultarOrgaosRequest } = request;

	let body = { ...payload };

	delete body.current;

	body = cleanEmpty(body) as ConsultarOrgaosRequest;

	const response: ApiResponse = yield call(
		getApi,
		token || '',
		PATH_SGU_API,
		`orgaos`,
		body,
	);

	if (response.status === 200 || response.status === 201) {
		yield put(consultarOrgaoSuccess(response));
	} else {
		yield put(consultarOrgaoFailure());
	}
}

export default all([
	takeLatest(Types.CONSULTAR_ORGAOS_REQUEST, consultarOrgaoRequest),
]);
